import { useEffect, useState } from 'react';
import { ChatBrandingService } from '@/services/ChatBrandingService';

const cacheKey = (key) => `cyberjob_chat_branding_${key}`;

const readCache = (key) => {
    try { return key ? JSON.parse(localStorage.getItem(cacheKey(key))) : null; } catch { return null; }
};

// Null while loading; cached per chat link so repeat visits render branded immediately.
const useChatBranding = (workflowId, linkKey) => {
    const [branding, setBranding] = useState(() => readCache(linkKey));

    useEffect(() => {
        if (!workflowId) return undefined;
        let cancelled = false;
        ChatBrandingService.getForWorkflow(workflowId)
            .then((data) => {
                if (cancelled) return;
                const next = { ...data, logoUrl: ChatBrandingService.assetUrl(data?.logoUrl) };
                setBranding(next);
                try { if (linkKey) localStorage.setItem(cacheKey(linkKey), JSON.stringify(next)); } catch { /* storage unavailable */ }
            })
            .catch(() => { if (!cancelled) setBranding((b) => b ?? {}); });
        return () => { cancelled = true; };
    }, [workflowId, linkKey]);

    return branding;
};

export default useChatBranding;
